import { useTranslation } from 'react-i18next'
import {
  faCircleXmark,
  faHourglass,
  faCircle,
} from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { EvaluationResponseStatus } from 'enum/evaluationResponseStatus.enum'
import { prefixColumns } from '../constants'

interface IState {
  i18nKey: string
  icon: React.ReactNode
}

const finished: IState = {
  i18nKey: `${prefixColumns}.states.finished`,
  icon: <FontAwesomeIcon icon={faCircle} color="#00B47C" />,
}

const failed: IState = {
  i18nKey: `${prefixColumns}.states.failed`,
  icon: <FontAwesomeIcon icon={faCircleXmark} color="#F5222D" />,
}

const inProgress: IState = {
  i18nKey: `${prefixColumns}.states.inProgress`,
  icon: <FontAwesomeIcon icon={faHourglass} color="#FAAD14" />,
}

const STATUS_MAP: Record<EvaluationResponseStatus, IState> = {
  [EvaluationResponseStatus.completed]: finished,
  [EvaluationResponseStatus.abandoned]: failed,
  [EvaluationResponseStatus.inProgress]: inProgress,
  [EvaluationResponseStatus.notStarted]: inProgress,
}

interface StatusProps {
  status?: EvaluationResponseStatus
}

const Status = ({ status }: StatusProps) => {
  const { t } = useTranslation()

  const STATUS =
    STATUS_MAP[status || EvaluationResponseStatus.notStarted] || inProgress
  return (
    <span>
      {STATUS.icon} <span className="ml-1">{t(STATUS.i18nKey)}</span>
    </span>
  )
}

export default Status
